
import { useAuth } from '@/context/AuthContext';

/**
 * Hook to provide mapping between old and new role names during the transition period
 * This helps maintain compatibility while migrating from old role names to new ones
 */
export function useRoleMapping() {
  const { profile } = useAuth();
  
  if (!profile) {
    return {
      isAdmin: false,
      isIndividual: false,
      isCorporate: false
    };
  }
  
  // Map old role names to new ones for compatibility during migration
  // We need to use type assertion to allow string comparison
  const role = profile.role as string;
  const isIndividual = role === 'individual' || role === 'candidat';
  const isCorporate = role === 'corporate' || role === 'entreprise' || role === 'recruteur';
  const isAdmin = role === 'admin';
  
  return {
    isAdmin,
    isIndividual,
    isCorporate
  };
}
